/* eslint-disable */
import docketsListSettings from './Actions/DocketsListSettings.action';

const docketsActionCreators = {
  docketsListSettings,
};

export default docketsActionCreators;
